module.exports = __webpack_public_path__ + "static/media/title.84ebbb02.png";